<input #input type="text" inputmode="decimal" [attr.aria-label]="ariaLabel" (keydown)="onKeyDown($event)" (input)="onInput($event)" />
